export default "__VITE_ASSET__BdJXJtdY__"